import { db } from "../firebase/config";
import getTime from "./getTime";

const addSubscriber = (email: string) => {
  db.collection("subscribers").doc(email).set(
    {
      email,
      createdAt: getTime(),
    },
    { merge: true }
  );
};

export default addSubscriber;
